export default __webpack_public_path__ + "static/réglement-intérieur-bd24e09336ed69efbae96bf8f45b6e78.pdf";